import { Injectable } from '@angular/core';

import { AnalyticsBase } from '../lib/analytics-base';

@Injectable()
export class ProfileAnalytics extends AnalyticsBase {
  public readonly namespace = 'Profile';
  public readonly requireViewContext = true;

  public trackEmailActivation(provider: string) {
    this.track('ActivateEmail', { provider });
  }

  public trackCalendarSync(provider: string) {
    this.track('SyncCalendar', { provider });
  }
}
